import { Image } from 'expo-image';
import { type CSSProperties, useEffect, useState } from 'react';

import type { BackgroundVideoPlayerProps } from './types';

const fillStyle = {
  position: 'absolute',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  width: '100%',
  height: '100%',
} as const;

export function BackgroundVideoPlayer({
  videoUrl,
  posterUrl,
  mediaAltText,
  style,
  hideFromAccessibility = false,
}: BackgroundVideoPlayerProps) {
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);
  const posterLabel = mediaAltText?.trim() || 'Hero background video';

  useEffect(() => {
    setIsVideoPlaying(false);
  }, [videoUrl]);

  return (
    <>
      {videoUrl && (
        <video
          src={videoUrl}
          poster={posterUrl ?? undefined}
          aria-hidden={hideFromAccessibility || undefined}
          aria-label={hideFromAccessibility ? undefined : posterLabel}
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
          onPlaying={() => setIsVideoPlaying(true)}
          onError={() => setIsVideoPlaying(false)}
          style={{
            ...(style as unknown as CSSProperties),
            ...fillStyle,
            objectFit: 'cover',
          }}
        />
      )}

      {!isVideoPlaying && posterUrl && (
        <Image
          source={posterUrl}
          accessibilityLabel={hideFromAccessibility ? undefined : posterLabel}
          alt={hideFromAccessibility ? undefined : posterLabel}
          accessible={!hideFromAccessibility}
          style={[style, fillStyle]}
          contentFit="cover"
          contentPosition="center"
        />
      )}
    </>
  );
}
